/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Inventory_SkuInputs */

const vi_report_inventory_sku = /** @type {(inputs: Report_Inventory_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SKU`)
};

/**

* @param {Report_Inventory_SkuInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_inventory_sku = /** @type {((inputs?: Report_Inventory_SkuInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Inventory_SkuInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_inventory_sku(inputs)
});